import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { ArrowUpRight, Sparkles } from "lucide-react";

const CTASection = () => {
  const { t, language } = useLanguage();

  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="py-10 lg:py-14 relative overflow-hidden">
      {/* Metallic silver gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-100 via-slate-200/80 to-slate-100" />
      <div className="absolute inset-0 bg-gradient-to-r from-white/40 via-slate-300/20 to-white/40" />
      {/* Subtle shine effect */}
      <div className="absolute inset-0 bg-[linear-gradient(135deg,transparent_40%,rgba(255,255,255,0.5)_50%,transparent_60%)]" />
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLW9wYWNpdHk9IjAuMDMiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-50" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Sparkles className="w-4 h-4 text-rose-500" />
              <span className="text-sm font-medium bg-gradient-to-r from-rose-500 to-violet-500 bg-clip-text text-transparent">
                {language === "fr" ? "Le résultat ?" : "The result?"}
              </span>
            </div>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-display font-bold text-slate-800 mb-2">
              {language === "fr" ? "Plus d'avis. Plus de visibilité. Plus de clients." : "More reviews. More visibility. More customers."}
            </h2>
            <p className="text-sm text-slate-500 max-w-lg">
              {language === "fr" 
                ? "Rejoignez les commerces qui transforment chaque visite en engagement digital mesurable."
                : "Join businesses that turn every visit into measurable digital engagement."}
            </p>
          </div>
          
          <Button
            onClick={scrollToContact}
            size="lg"
            className="bg-gradient-to-r from-rose-500 to-violet-500 hover:from-rose-400 hover:to-violet-400 text-white font-semibold px-8 py-6 rounded-full shadow-lg shadow-rose-500/30 transition-all duration-300 hover:scale-105 group flex-shrink-0"
          >
            {t("cta.button")}
            <ArrowUpRight className="ml-2 h-5 w-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;